<template>
  <div class="page page-expertise">
    <div
      class="page__wrap p-top-xxxl-1 p-bottom-xxxl-1"
      data-animate="page-wrap"
    >
      <div class="row-1">
        <PagesCommonTextHeader
          v-if="page"
          :title="page.title"
          :intro="page.introText"
          :subtitle="page?.subtitle"
          class="--align-left"
        />
      </div>
      <div data-animate="preloader-opacity">
        <section v-if="page.highlightReel && page.highlightReel.gridModule" class="m-top-1 p-bottom-1 row-1">
         <ul class="">
          <li v-for="(item, index) in page.highlightReel.gridModule" :key="item.id" class="page-reels__highlight-item">
            <PagesReelsGridListBlock
              :order="index"
              :item="item"
              :link-route="'reels-slug'"
              :alternative="true"
            />
          </li>
         </ul>

        </section>
       <section v-if="page.gridReels && page.gridReels.gridModule" class="p-bottom-xxxl-1 row-1" :class="{'m-top-xxl-1': !(page.highlightReel && page.highlightReel.gridModule), 'm-top-m-1': page.highlightReel && page.highlightReel.gridModule}">
          <PagesReelsGridList
            :list="page.gridReels.gridModule"
            :link-route="'expertise-slug'"
            :alternative="true"
          />
        </section>

        <template v-if="page && page.body && page.body.length">
          <section
            data-animate="preloader-opacity"
            class="page-expertise__section-grid"
            v-for="item in page.body"
            :key="item.id"
          >
            <template v-if="item.__typename === 'GridSectionRecord'">
              <WidgetContentStickyExsud
                :title="item.title"
                :align-left="item.alignment === 'left' ? true : false"
              >
                <template v-slot:content>
                  <PagesCommonGridParallax
                    v-for="(block, indexRow) in item.gridRows"
                    :key="indexRow"
                    :items="block.items"
                    :reverse="indexRow % 2 !== 0"
                    :class="{
                      'm-top-xl-1': indexRow > 0,
                    }"
                    :has-parallax="false"
                    class="-not-homepage row-1"
                  />
                </template>
              </WidgetContentStickyExsud>
            </template>
            <template v-if="item.__typename === 'CtaBlockRecord'">
              <div class="row-1 section-cta-block">
                <WidgetBannerCtaSlim
                  :key="item.id"
                  :banner="item"
                  v-if="item.slim"
                />
                <WidgetBannerCta v-else :banner="item" :key="item.id" />
              </div>
            </template>
            <template v-if="item.__typename === 'IndustriesBlockRecord'">
              <template v-if="page?.ctaDefaultPosition === 'top-industries'">
                <template v-if="page?.ctaType === 'Custom'">
                  <div v-if="page.contactBannerBlock" class="row-1 m-top-xl-1">
                    <WidgetBannerCtaSlim :banner="page.contactBannerBlock" />
                  </div>
                </template>
                <template v-else>
                  <div class="row-1 m-top-xl-1">
                    <client-only>
                      <!--<ContactBanner v-if="contactBanner || contactBanner2"
                        :type="page?.ctaType === 'Contact Banner 2' ? 2 : 1"
                        :banner="page.ctaType === 'Contact Banner 2' &&  contactBanner2 ? contactBanner2 : contactBanner"          
                      />-->
                      <WidgetBannerCtaSlim
                        v-if="contactBanner || contactBanner2"
                        :banner="
                          page.ctaType === 'Contact Banner 2' && contactBanner2
                            ? contactBanner2
                            : contactBanner
                        "
                      />
                    </client-only>
                  </div>
                </template>
              </template>
              <section
                class="--grey-background p-top-m-1 m-top-xl-1 p-bottom-m-1 industries-block-section"
              >
                <div class="row-1">
                  <template v-if="industriesContent">
                    <div
                      v-if="item.title !== ''"
                      class="title-m-3 is-text-center m-bottom-1 is-text-uppercase"
                      v-html="item.title"
                      v-anim-reveal-text
                    />
                    <div
                      v-else
                      class="title-m-3 is-text-center m-bottom-1 is-text-uppercase"
                      v-html="industriesContent.block.title"
                      v-anim-reveal-text
                    />
                    <div
                      v-if="item.text !== ''"
                      class="text-xl-3 is-text-center m-bottom-m-1 --max-width-text"
                      v-html="item.text"
                      v-anim-reveal-text
                    />
                    <div
                      v-else
                      class="text-xl-3 is-text-center m-bottom-m-1 --max-width-text"
                      v-html="industriesContent.block.text"
                      v-anim-reveal-text
                    />
                  </template>

                  <PagesHomeTechnologyList
                    :industries="allIndustries"
                    class="p-bottom-m-1"
                    v-if="!item.showCarousel"
                  />
                </div>
                <template v-if="item.showCarousel">
                  <PagesIndustriesCarousel
                    :slides="allIndustries"
                    :item="{ isVertical: true }"
                  />
                </template>
              </section>
            </template>
            <template v-if="item.__typename === 'ClinicalAreasBlockRecord'">
              <template v-if="page?.ctaDefaultPosition === 'top-clinical'">
                <template v-if="page?.ctaType === 'Custom'">
                  <div v-if="page.contactBannerBlock" class="row-1 m-top-xl-1">
                    <WidgetBannerCtaSlim :banner="page.contactBannerBlock" />
                  </div>
                </template>
                <template v-else>
                  <div class="row-1 m-top-xl-1">
                    <client-only>
                      <!--<ContactBanner v-if="contactBanner || contactBanner2"
                      :type="page?.ctaType === 'Contact Banner 2' ? 2 : 1"
                      :banner="page.ctaType === 'Contact Banner 2' &&  contactBanner2 ? contactBanner2 : contactBanner"          
                    />-->
                      <WidgetBannerCtaSlim
                        v-if="contactBanner || contactBanner2"
                        :banner="
                          page.ctaType === 'Contact Banner 2' && contactBanner2
                            ? contactBanner2
                            : contactBanner
                        "
                      />
                    </client-only>
                  </div>
                </template>
              </template>
              <template
                v-if="
                  clinicalAreas &&
                  clinicalAreas.aree &&
                  clinicalAreas.aree.length > 0
                "
              >
                <section
                  class="--grey-background p-top-m-1 p-bottom-m-1 clinical-block-section"
                >
                  <div class="row-1">
                    <template v-if="clinicalAreasContent">
                      <div
                        v-if="item.title !== ''"
                        class="title-m-3 is-text-center m-bottom-1 is-text-uppercase"
                        v-html="item.title"
                        v-anim-reveal-text
                      />
                      <div
                        v-else
                        class="title-m-3 is-text-center m-bottom-1 is-text-uppercase"
                        v-html="clinicalAreasContent.block.title"
                        v-anim-reveal-text
                      />
                    </template>
                    <template v-else>
                      <div
                        v-if="item.title !== ''"
                        class="title-m-3 is-text-center m-bottom-1 is-text-uppercase"
                        v-html="item.title"
                        v-anim-reveal-text
                      />
                    </template>
                    <template v-if="clinicalAreasContent">
                      <div
                        v-if="item.text !== ''"
                        class="text-xl-3 is-text-center m-bottom-m-1 --max-width-text"
                        v-html="item.text"
                        v-anim-reveal-text
                      />
                      <div
                        v-else
                        class="text-xl-3 is-text-center m-bottom-m-1 --max-width-text"
                        v-html="clinicalAreasContent.block.text"
                        v-anim-reveal-text
                      />
                    </template>
                    <template v-else>
                      <div
                        v-if="item.text !== ''"
                        class="text-xl-3 is-text-center m-bottom-m-1 --max-width-text"
                        v-html="item.text"
                        v-anim-reveal-text
                      />
                    </template>
                  </div>
                  <client-only>
                    <!-- <NuxtMarquee :speed="60" :autofill="true" :class="'clinical-areas-marquee m-top-l-1'">
                        <template v-for="area in clinicalAreas.aree" :key="area.id">
                          <PagesClinicalAreasBlock :item="area" />
                        </template>
                      </NuxtMarquee>-->
                    <div class="clinical-areas-carousel__swiper m-top-l-1">
                      <WidgetSliderSwiper
                        :length="clinicalAreas.aree?.length"
                        :small="true"
                      >
                        <template
                          v-for="(slide, index) in clinicalAreas.aree"
                          :key="index"
                          #[`slide-${index}`]
                        >
                          <PagesClinicalAreasBlock :item="slide" />
                        </template>
                      </WidgetSliderSwiper>
                    </div>
                  </client-only>

                  <div
                    v-if="item.showLink"
                    class="general-content-link-central m-top-1"
                  >
                    <nuxt-link
                      :to="localePath({ name: 'clinical-areas' })"
                      class="button-round-1 is-grey"
                    >
                      <span>{{ $t('cta.discover-more') }}</span>
                    </nuxt-link>
                  </div>
                </section>
              </template>
            </template>
            <template v-if="item.__typename === 'ClientiLoghiBlockRecord'">
              <template v-if="page?.ctaDefaultPosition === 'top-logos'">
                <template v-if="page?.ctaType === 'Custom'">
                  <div v-if="page.contactBannerBlock" class="row-1 m-top-xl-1">
                    <WidgetBannerCtaSlim :banner="page.contactBannerBlock" />
                  </div>
                </template>
                <template v-else>
                  <div class="row-1 m-top-xl-1">
                    <client-only>
                      <WidgetBannerCtaSlim
                        v-if="contactBanner || contactBanner2"
                        :banner="
                          page.ctaType === 'Contact Banner 2' && contactBanner2
                            ? contactBanner2
                            : contactBanner
                        "
                      />
                    </client-only>
                  </div>
                </template>
              </template>
              <section v-if="clienti" class="clienti-logos-section m-top-xl-1">
                <div class="row-1">
                  <div
                    v-html="item.title !== '' ? item.title : clienti.title"
                    class="title-m-3 is-text-center m-bottom-l-1 is-text-uppercase"
                    v-anim-reveal-text
                  />
                  <PagesStudioImagesGrid :images="clienti.imagesList" />
                </div>
              </section>
            </template>
            <template v-if="item.__typename === 'LinkBlockRecord'">
              <div class="row-1">
                <div class="general-content-link-central m-top-l-2">
                  <WidgetLink
                    v-if="item.internalLink"
                    :link="{
                      label: item.linkLabel,
                      link: item.internalLink,
                    }"
                    class="button-round-1 is-big is-gradient-reverse"
                  />

                  <a
                    v-else
                    :href="item.linkUrl"
                    class="button-round-1 is-big is-gradient-reverse"
                    target="_blank"
                  >
                    <span>{{ item.linkLabel }}</span>
                  </a>
                </div>
              </div>
            </template>
          </section>
        </template>
        <template v-if="page?.ctaDefaultPosition === 'bottom'">
          <template v-if="page?.ctaType === 'Custom'">
            <div v-if="page.contactBannerBlock" class="row-1 m-top-xl-1">
              <WidgetBannerCtaSlim :banner="page.contactBannerBlock" />
            </div>
          </template>
          <template v-else>
            <div class="row-1 m-top-xl-1">
              <client-only>
                <!--<ContactBanner v-if="contactBanner || contactBanner2"
              :type="page?.ctaType === 'Contact Banner 2' ? 2 : 1"
               :banner="page.ctaType === 'Contact Banner 2' &&  contactBanner2 ? contactBanner2 : contactBanner"          
            />-->
                <WidgetBannerCtaSlim
                  v-if="contactBanner || contactBanner2"
                  :banner="
                    page.ctaType === 'Contact Banner 2' && contactBanner2
                      ? contactBanner2
                      : contactBanner
                  "
                />
              </client-only>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import queries from '@/graphql/dato/queries/index.js'

import pageTransition from '@/assets/js/transitions/helper.js'

definePageMeta({
  layout: 'default',
  pageTransition,
})

const { locale } = useI18n()

const query = queries.reels.getReelsPage
const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(query, variables)
console.log(data)
if (!data.value?.reelsPage) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data.value?.reelsPage)
const clienti = computed(() => data.value?.clientiSection)
//const allExpertises = computed(() => data.value?.allExpertises)
const industriesContent = computed(() => data.value?.industriesListBlock)
const allIndustries = computed(() => data.value?.allIndustries)
const clinicalAreasContent = computed(() => data.value?.clinicalAreasListBlock)
const clinicalAreas = computed(() => data.value?.clinicalAreaPage)
const contactBanner = computed(() => data.value?.contactBanner)
const contactBanner2 = computed(() => data.value?.contactBanner2)

const seo = computed(() => data.value?.reelsPage?.seo || {})
//const localeParams = computed(() => project.value?._allSlugLocales || [])

/*const listGridTotal = computed(() => {
  const blocks = []
  if (data.value?.allExpertises) {
    blocks.concat(data.value.allExpertises)
  }
  return blocks
    .concat(data.value?.allExpertises)
    .concat(data.value?.expertiseListing?.extraGrid)
})*/
// Seo
useSeo({
  ...seo.value,
  //localeParams: useHelpers().generateSeoLocaleParams(localeParams, 'slug'),
})

useStructuredData().setBreadcrumb({ section: 'reels' })
</script>
